import { createArtLabelUpload } from "../artLabels/functions";
import { uploadImage } from "../artLabels/uploadPng";
import { extendedArtErrorMessage } from "./functions";

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_TYPES = ["image/png", "image/jpeg"];

/** Mesmas regras do backend (INVALID_UPLOAD): PNG ou JPEG, até 10 MB. */
export const validateArtFile = (file) => {
    if (!file) return "Escolha um arquivo.";
    if (!ACCEPTED_TYPES.includes(file.type)) return "Envie PNG ou JPEG.";
    if (file.size > MAX_UPLOAD_BYTES) return "A imagem passa de 10 MB.";
    return null;
};

/** Presign em /admin/art-labels/uploads e PUT direto no S3 com o mesmo Content-Type. */
export async function uploadArtSource(token, file) {
    const presign = await createArtLabelUpload(token, file.type);
    if (presign?.type !== "success") {
        throw new Error(extendedArtErrorMessage(presign?.code, presign?.message || "Erro ao preparar o envio da imagem"));
    }
    try {
        await uploadImage(presign.data.uploadUrl, file, file.type);
    } catch (error) {
        // `fetch` rejeita em inglês ("Failed to fetch") quando a rede cai.
        throw new Error(`Falha ao enviar a imagem: ${error?.message || "erro de rede"}`);
    }
    return { artKey: presign.data.artKey, s3Key: presign.data.s3Key };
}
